<div data-testid="loan-amounts-loan-amounts-grid-container" class="loan-amounts-grid-container">
  <!-- Toolbar row: checkbox on left, add button on right -->
  <div data-testid="loan-amounts-custom-toolbar" class="custom-toolbar">
    <div data-testid="loan-amounts-checkbox-overlay" class="checkbox-overlay" [class.disabled]="shouldDisableCheckbox">
      <dx-check-box
        [text]="activeLoanCheckboxText"
        [value]="showInactiveLoans"
        [disabled]="shouldDisableCheckbox"
        (onValueChanged)="onCheckboxChange($event)">
      </dx-check-box>
    </div>

    <dx-button data-testid="loan-amounts-button"
      icon="add"
      type="default"
      stylingMode="outlined"
      (onClick)="addNewRow()"
      [disabled]="isGridInEditMode">
    </dx-button>
  </div>

  <!-- Data Grid -->
  <dx-data-grid data-testid="loan-amounts-data-grid" [dataSource]="loanAmounts" keyExpr="key" [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true" (onRowInserted)="onRowInserted($event)" (onRowUpdated)="onRowUpdated($event)" (onRowRemoved)="onRowRemoved($event)" (onEditingStart)="onEditingStart($event)" (onEditCanceled)="onEditCanceled($event)" (onContentReady)="onContentReady($event)" (onInitialized)="onGridInitialized($event.component)">

    <!-- Editing configuration -->
    <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true" [confirmDelete]="false">
    </dxo-editing>

    <!-- Columns -->
    <dxi-column dataField="loanNumber" caption="Loan Number" dataType="string" cellTemplate="cell">
      <dxo-lookup [dataSource]="getLoanData()" valueExpr="name" displayExpr="name">
        <div *dxTemplate="let data of 'item'">
          <span [style.color]="data.status === 'Inactive' ? 'red' : 'inherit'">
            {{ data.name }} ({{ data.status }})
          </span>
        </div>
      </dxo-lookup>
      <div *dxTemplate="let cellData of 'cell'">
        <span [style.color]="getLoanStatusColor(cellData.value)" style="font-weight: normal;">
          {{ getLoanDisplayText(cellData.value) }}
        </span>
      </div>
      <dxi-validation-rule type="required" message="Loan Number is required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column *ngIf="showAmountColumn" dataField="amount" caption="Amount" dataType="number" format="#,##0.##">
      <dxi-validation-rule type="required" message="Amount is required"></dxi-validation-rule>
      <dxi-validation-rule type="range" [min]="0" message="Amount must be greater than zero"></dxi-validation-rule>
    </dxi-column>

    <!-- Action column for row-level edit/delete buttons -->
    <dxi-column type="buttons" [width]="100">
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
    </dxi-column>

  </dx-data-grid>
</div>